// import { Image } from "react-bootstrap";
import classNames from 'classnames';
import React, { useMemo } from 'react';
import Image from 'react-bootstrap/Image';
import { createUseStyles } from 'react-jss';
import { Feature, useFeature } from '../../hooks/use-feature';
import { useStorage } from '../../hooks/use-storage';
import { layoutDefaults } from '../../utils/layout-defaults';
import { useMenuManager } from '../../utils/manager/menu-manager';
import { useAnalytics } from '../../utils/setup/analytics-setup';
import { BannerPaper } from '../banner/banner-paper';
import { SearchBar } from '../header/search-bar';
import { ChangeLangButton } from '../language/change-lang-button';

function Header() {
  const { analyticsHollowEvent } = useAnalytics();
  const { menuLayout, language, languages } = useStorage();
  const { getMenuLogo } = useMenuManager();
  const { isFeatureAvailable } = useFeature();

  const menuLogo = useMemo(() => getMenuLogo(), [menuLayout]);

  const maxWidth = useMemo(() => {
    if (menuLogo.size === 'big') {
      return '60%';
    }

    if (menuLogo.size === 'medium') {
      return '48%';
    }

    return '36%';
  }, [menuLogo]);

  const classes = useStyles({ layout: menuLayout, maxWidth });

  const onPress = () => {
    analyticsHollowEvent('banner click');
  };

  return (
    <div className={classes.container}>
      <div
        className={classNames(
          classes.bannerContainer,
          'animate__animated animate__fadeIn animate__delay-1s'
        )}
        style={{ '--animate-delay': '0.4s' }}
      >
        <div className={classes.imageContainer}>
          <Image
            className={classNames(
              classes.logo,
              'animate__animated animate__fadeInDown animate__delay-2s'
            )}
            style={{ '--animate-delay': '0.4s' }}
            src={menuLogo?.url}
            fluid
            onClick={onPress}
          />
        </div>
        <BannerPaper />

        {isFeatureAvailable(Feature.TRANSLATION) && (
          <ChangeLangButton selectedLanguage={language} languages={languages} />
        )}
      </div>
      <SearchBar />
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    position: 'relative',
    zIndex: 100,
  },
  bannerContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    backgroundColor: ({ layout }) => layout?.background?.default_color,

    // border: '1px solid white',
  },
  // bannerContainer: {
  //   border: '1px solid white',
  // },
  image: {
    width: '100%',
  },
  logo: {
    marginRight: layoutDefaults.biggerHorizontalMargin,
    maxWidth: ({ maxWidth }) => maxWidth,
    marginTop: layoutDefaults.bigVerticalMargin,
    paddingBottom: layoutDefaults.bigVerticalMargin,

    // border: '1px solid white',
  },
});

export { Header };
